<router-outlet></router-outlet>
<notifier-container></notifier-container>
<app-session-expiry *ngIf="showSessionExpiry" (onAction)="showSessionExpiry = false"></app-session-expiry>
<app-cookies-preferences class="position-absolute cookies" *ngIf="showCookiePreferences()"></app-cookies-preferences>
